export default {"src":"/_next/static/media/icon_party.72da92f1.svg","height":33,"width":33,"blurWidth":0,"blurHeight":0};